import React from 'react';
import PropTypes from 'prop-types';
import styles from './Badge.module.scss';

const Badge = ({ text, onClickButton, isReadOnly }) => (
  <div className={styles.badge}>
    <div>{text}</div>
    {!isReadOnly && (
      <div
        className={styles['btn-delete-badge']}
        onClick={onClickButton}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            onClickButton();
          }
        }}
        role="button"
        tabIndex="0"
        data-testid="btn-delete-badge"
        aria-label={text}
      />
    )}
  </div>
);

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  onClickButton: PropTypes.func,
  isReadOnly: PropTypes.bool,
};

Badge.defaultProps = {
  isReadOnly: false,
  onClickButton: () => {},
};

export default Badge;
